module.exports = new __parcel__URL__("dark_matter_icon_large.98e48a4d.png").toString();